import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    btn: {
        height: 56,
    }
}))